"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Document operations. */
var DocumentImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Document class.
   * @param client Reference to the service client
   */
  function DocumentImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[documentPath, portalId])
   * @param portalId (Access Controlled)
   * @param documentPath (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentImpl, [{
    key: "getDocumentInfo",
    value: function getDocumentInfo(portalId, documentPath, options) {
      var operationArguments = {
        portalId: portalId,
        documentPath: documentPath,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentInfoOperationSpec);
    }
    /**
     * This is v2 version of
     * M:Schultz.Rhinestone.Portal.Web.Controllers.api.Document.DocumentController.GetDocumentInfo(System.Guid,System.String)
     * action.
     * It was added to avoid breaking public endpoint contract.
     * Comparing to v1 version, returned document properties and taxons have different properties.
     * For properties, Name and Value properties instead of OuterXml property.
     * For taxons, HiveId is missing and Title has been added. (Auth: RhinestoneAuthorize[documentPath,
     * portalId])
     * @param portalId (Access Controlled)
     * @param documentPath (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocument",
    value: function getDocument(portalId, documentPath, options) {
      var operationArguments = {
        portalId: portalId,
        documentPath: documentPath,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[documentId, portalId])
     * @param portalId (Access Controlled)
     * @param documentId (Access Controlled)
     * @param revisionNumber
     * @param variantTypeCode
     * @param index
     * @param options The options parameters.
     */

  }, {
    key: "getPrimaryPart",
    value: function getPrimaryPart(portalId, documentId, revisionNumber, variantTypeCode, index, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        revisionNumber: revisionNumber,
        variantTypeCode: variantTypeCode,
        index: index,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPrimaryPartOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[documentId, portalId])
     * @param portalId (Access Controlled)
     * @param documentId (Access Controlled)
     * @param revisionNumber
     * @param variantTypeCode
     * @param name
     * @param options The options parameters.
     */

  }, {
    key: "getSupplementalPartFromDocumentId",
    value: function getSupplementalPartFromDocumentId(portalId, documentId, revisionNumber, variantTypeCode, name, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        revisionNumber: revisionNumber,
        variantTypeCode: variantTypeCode,
        name: name,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSupplementalPartFromDocumentIdOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param variantType
     * @param sectionName
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSection",
    value: function getDocumentSection(portalId, variantType, sectionName, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        variantType: variantType,
        sectionName: sectionName,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param variantType
     * @param sectionIds Array of Get2ItemsItem
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSections",
    value: function getDocumentSections(portalId, variantType, sectionIds, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        variantType: variantType,
        sectionIds: sectionIds,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSectionsOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getPrimaryVariantContentExcludeEditorialNotes",
    value: function getPrimaryVariantContentExcludeEditorialNotes(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPrimaryVariantContentExcludeEditorialNotesOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param variantType
     * @param portalId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getVariantContent",
    value: function getVariantContent(hiveId, fullName, variantType, portalId, options) {
      var operationArguments = {
        hiveId: hiveId,
        fullName: fullName,
        variantType: variantType,
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getVariantContentOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param fieldSetName
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getFieldSetValues",
    value: function getFieldSetValues(portalId, fieldSetName, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        fieldSetName: fieldSetName,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getFieldSetValuesOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param variantTypeCode
     * @param options The options parameters.
     */

  }, {
    key: "getSupplementalPartFromHiveAndFullname",
    value: function getSupplementalPartFromHiveAndFullname(portalId, hiveId, fullName, variantTypeCode, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        variantTypeCode: variantTypeCode,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSupplementalPartFromHiveAndFullnameOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentTableOfContent",
    value: function getDocumentTableOfContent(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentTableOfContentOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentProperties",
    value: function getDocumentProperties(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentPropertiesOperationSpec);
    }
    /**
     * @param portalId
     * @param hiveId
     * @param fullName
     * @param options The options parameters.
     */

  }, {
    key: "tryGetPdfVariant",
    value: function tryGetPdfVariant(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, tryGetPdfVariantOperationSpec);
    }
  }]);
  return DocumentImpl;
}(); // Operation Specifications


exports.DocumentImpl = DocumentImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getDocumentInfoOperationSpec = {
  path: "/api/v1/portals/{portalId}/portaldocuments/{documentPath}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentInfo
    },
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentPath],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentOperationSpec = {
  path: "/api/v2/portals/{portalId}/portaldocuments/{documentPath}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentDto
    },
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentPath],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getPrimaryPartOperationSpec = {
  path: "/api/v1/portals/{portalId}/documents/{documentId}/revisions/{revisionNumber}/variants/{variantTypeCode}/primaryParts/{index}",
  httpMethod: "GET",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId, Parameters.index, Parameters.revisionNumber, Parameters.variantTypeCode],
  serializer: serializer
};
var getSupplementalPartFromDocumentIdOperationSpec = {
  path: "/api/v1/portals/{portalId}/documents/{documentId}/revisions/{revisionNumber}/variants/{variantTypeCode}/supplementalParts/{name}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId, Parameters.revisionNumber, Parameters.variantTypeCode, Parameters.name],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};
var getDocumentSectionOperationSpec = {
  path: "/api/Portals({portalId})/Document/{variantType}/{sectionName}/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.variantType, Parameters.sectionName],
  headerParameters: [Parameters.accept4],
  serializer: serializer
};
var getDocumentSectionsOperationSpec = {
  path: "/api/Portals({portalId})/DocumentSectionsById/{variantType}/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.sectionIds],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.variantType],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getPrimaryVariantContentExcludeEditorialNotesOperationSpec = {
  path: "/api/Portals({portalId})/Documents/LocalPrimaryVariant/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  queryParameters: [Parameters.assetCollectionId1],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept4],
  serializer: serializer
};
var getVariantContentOperationSpec = {
  path: "/api/Portals({portalId})/Documents/Variant({variantType})/Content/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.variantType],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};
var getFieldSetValuesOperationSpec = {
  path: "/api/Portals({portalId})/Documents/FieldSetValues({fieldSetName})/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.fieldSetName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getSupplementalPartFromHiveAndFullnameOperationSpec = {
  path: "/api/Portals({portalId})/Documents/Variant({variantTypeCode})/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  queryParameters: [Parameters.partName],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.variantTypeCode],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};
var getDocumentTableOfContentOperationSpec = {
  path: "/api/Portals({portalId})/Documents/Toc/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.Toc
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentPropertiesOperationSpec = {
  path: "/api/Portals({portalId})/Documents/Properties/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentPropertyModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.properties],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var tryGetPdfVariantOperationSpec = {
  path: "/api/Portals({portalId})/Print/h/{hiveId}/{fullName}",
  httpMethod: "HEAD",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  serializer: serializer
};